import { render, staticRenderFns } from "./GroupFeaturedSectionListV2.vue?vue&type=template&id=f281333c&scoped=true&"
import script from "./GroupFeaturedSectionListV2.vue?vue&type=script&lang=js&"
export * from "./GroupFeaturedSectionListV2.vue?vue&type=script&lang=js&"
import style0 from "./GroupFeaturedSectionListV2.vue?vue&type=style&index=0&id=f281333c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f281333c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
